<template>
  <el-row>
    <el-button size="medium" @click="gourl('1')" round>学生档案</el-button>
    <el-button size="small" @click="gourl('2')" round>学生心理档案</el-button>
    <el-button size="mini" @click="gourl('3')" round>超小按钮</el-button>
  </el-row>
</template>


<script>
export default {
  data(){
    return {

    }
  },
  methods:{
    gourl(lu){
      this.$router.push(lu);
    }
  }
}
</script>